import React from 'react'
import StarRatings from '../../StarRatings/StarRatings'
import { ChevronRight } from 'react-bootstrap-icons'
import { shortenTextSectionForLineClamp } from '@/utils/shortenTextSelectionForLineClamp'

const SHORT_DESCRIPTION_CHAR_LIMIT = 160

export default function ReviewsCard({
  slug,
  reviewImage,
  title,
  name,
  rating,
  capacity,
  shortDescription
}: {
  slug: string
  reviewImage: string
  title: string
  name: string
  rating: number
  capacity: string
  shortDescription: string
}): JSX.Element {
  const description = shortenTextSectionForLineClamp(
    shortDescription,
    SHORT_DESCRIPTION_CHAR_LIMIT
  )

  return (
    <a
      href={`/${slug}/`}
      target="_blank"
      rel="noreferrer"
      className="flex h-full min-w-[282px] max-w-[282px] shrink-0 flex-col gap-4 rounded-xl border border-gray-300 bg-white p-6 md:w-fit md:flex-1 md:shrink"
    >
      <div className="flex items-center leading-3">
        <StarRatings
          rating={rating}
          starRatedColor="#FFC130"
          starSpacing="2px"
          numberOfStars={5}
          starDimension="12px"
          uniqueKey="spotlight-card"
        />
      </div>
      <div className="flex flex-col items-start justify-center gap-1">
        <div className="font-medium text-gray-1100">{name}</div>
        <div className="text-sm font-normal text-gray-800 ">{capacity}</div>
      </div>

      <div className="line-clamp-6 grow text-gray-900 ">{description}</div>

      <div className="h-px w-full bg-gray-200 px-1" />
      <div className="flex h-11 items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <img
            src={reviewImage}
            className="size-10 rounded-lg object-cover"
            loading="lazy"
          />
          <div className="line-clamp-2 font-FieldsVariable font-medium leading-[22px] text-gray-1100">
            {title}
          </div>
        </div>
        <div className="flex items-center justify-center">
          <ChevronRight className="size-4 text-gray-1100" />
        </div>
      </div>
    </a>
  )
}
